import React from "react";
import dataFormat from "@home/utils/dbDataFormat/dataFormat";
import "./index.scss";

interface IOpinionsCard {
  title: string;
  value: number;
  dataValue?: any;
  formatRule?: string;
  header?: React.ReactNode;
  footer?: React.ReactNode;
}
const OpinionsCard = (props: IOpinionsCard) => {
  const { title, value, dataValue, formatRule = "bmk00", header, footer } = props || {};
  return (<div className='dbh-opinions-metric-card' key={title}>
    {header}
    <div className='dbh-opinions-metric-card-title'>{title}</div>
    <div className='dbh-opinions-metric-card-value'>{dataValue || dataFormat({ value, formatRule })}</div>
    {footer}
  </div>);
};

export default OpinionsCard;